module.exports = __webpack_public_path__ + "static/media/eliberty5.c9cc67b7.jpg";